import axios from 'axios'
import createDebug from 'debug'

import * as apiRoutes from '@shared/api-routes'
import store from '@/store/store'
import * as M from '@/store/mutations'

const apiDebug = createDebug('sbox:api')
const clientId = process.env.TWITCH_EXT_CLIENT_ID
const baseURL = process.env.EBS_ORIGIN + '/api'
const api = createInstance({ baseURL })

export async function initAPI () {
    // store.watch(state => state.twitch.auth.token, token => {
    //     //setApiToken(token)
    // })
}

const publicRoutes = [
    apiRoutes.channelRoute,
    apiRoutes.emotesRoute,
]

const isPublicApi = path => publicRoutes.some(route => route.matches(path))
const authHeader = () => `Bearer ${store.state.twitch.auth.token}`

// Problem: Unnecessary OPTIONS requests are harming network performance,
// as seen on the goaccess dashboard.
//
// https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS
// Adding a non "CORS-safelisted request-header" will force an OPTIONS
// request, which adds latency. Don't send auth headers if not needed,
// such as for GET requests to publicly readable resources.
function shouldAddAuthHeaders (config) {
    const { url, method } = config

    let endpoint = url
    if (endpoint.charAt(0) !== '/') {
        endpoint = '/' + endpoint
    }

    const methodUrl = `${method} ${endpoint}`

    // Some GET requests require auth, such as querying the PENDING list.
    // To keep it simple, always send auth headers if user is broadcaster or mod.
    if (store.getters.isAdmin) {
        apiDebug(`Add auth b/c isAdmin: ${methodUrl}`)
        return true
    } else if (isPublicApi(endpoint)) {
        apiDebug(`No auth for public endpoint: ${methodUrl}`)
        return false
    }

    apiDebug(`Add auth by default: ${endpoint}`)

    return true
}

// status.json is a file i manually edit.
async function isPlannedDowntime () {
    try {
        const origin = process.env.SERVER_STATUS_ORIGIN
        const url = `${origin}/suggestion-box/status.json`
        const res = await axios.get(url)
        return res.data.status === 'down'
    } catch {
        return false
    }
}

function createInstance (config) {
    const instance = axios.create(config)

    instance.interceptors.request.use(async config => {
        if (shouldAddAuthHeaders(config)) {
            config.headers.Authorization = authHeader()
            config.headers['Client-Id'] = clientId
        }
        // Axios doesn't merge default params
        // https://github.com/axios/axios/issues/2190
        config.params = config.params || {}
        config.params.version = process.env.VERSION
        return config
    }, null)

    instance.interceptors.response.use(null, async error => {
        if (error.name === 'TokenExpiredError') {
            console.dir(error)
            cl('TOKEN EXPIRED')
        }
        return Promise.reject(error)
    })

    const MAX_TRANSACTION_RETRIES = 2

    instance.interceptors.response.use(null, async error => {
        const { config } = error
        const { url, __numRetries = 0 } = config
        const shouldRetry = (
            url.includes('/bounty') && __numRetries < MAX_TRANSACTION_RETRIES
        )
        // Retry twice. 3rd times the charm, right?
        if (shouldRetry) {
            config.__numRetries = __numRetries + 1
            return instance.request(config)
        }
        return Promise.reject(error)
    })

    // instance.interceptors.response.use(null, async error => {
    //     console.dir(error)
    //     // Uncomment when you need another planned downtime. Ideally, rarely.
    //     // const isNetworkErr = error.message === 'Network Error'
    //     // if (isNetworkErr && await isPlannedDowntime()) {
    //     //     store.commit(M.SET_PLANNED_DOWNTIME)
    //     // }
    //     return Promise.reject(error)
    // })

    return instance
}

export default api
